export default __webpack_public_path__ + "static/media/i_r.9dd1533d.wav";